<template>
  <div class="supervisor-list" :class="{ 'clear-header': isWechatBrowser }">
    <my-header
      title="优选工长"
      v-if="!isWechatBrowser"
      :showBack="true"
    ></my-header>
    <div class="foreman-top">工长流程</div>
    <div class="foreman-flow-part">
      <img class="icon-flow" src="../../assets/icon-foreman-flow.png" />
    </div>
    <img class="icon-advert" src="../../assets/gangmaster/icon-advert2.png" />
    <div class="Hyperlinks">
      <div
        class="Hyperlinks-content"
        v-for="(linkItem, index) in linkData"
        :key="index"
        @click="toLinkdetail(linkItem.linkId)"
      >
        #{{ linkItem.name }}
      </div>
    </div>
    <!--    <div class="section-title" v-if="linkData.length>0">施工规范</div>-->
    <!--    <div v-if="linkData.length>0" class="construction-norm-list">-->
    <!--      <div v-for="(linkItem,index) in linkData" @click="toLinkdetail(linkItem.linkId)" class="construction-norm-item" :class="{'construction-norm-space':index%2 != 1}">-->
    <!--        <div class="construction-norm-title">#{{linkItem.name}}</div>-->
    <!--        <img class="construction-norm-item-bg" src="https://img.shuimujiaju.com/54f7695ae6a249cf9835b1e573d00c99.png">-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-if="linkData.length==0" class="noimg">-->
    <!--      <img src="../../assets/icon-no-img.png">-->
    <!--      <div class="tip">暂无相关施工规范!</div>-->
    <!--    </div>-->
    <div class="search-container">
      <div class="border"></div>
      <div class="search">
        <div class="input">
          <img src="../../assets/icon/icon-search.png" class="search-icon" />
          <input
            v-model="searchKeyword"
            placeholder="搜索工长"
            class="input-inner"
            @keydown.enter="handleSearchClick"
          />
          <!--          <mt-field placeholder="请输入用户名" v-model="searchKeyword"></mt-field>-->
        </div>
        <div class="btn" @click="handleSearchClick">搜索</div>
      </div>
    </div>
    <div class="anchor-list">
      <div
        @click="goAnchor('#anchor-0')"
        class="item"
        :class="{ anchored: anchor == '#anchor-0' }"
      >
        整体装修
      </div>
      <div
        @click="goAnchor('#anchor-1')"
        class="item"
        :class="{ anchored: anchor == '#anchor-1' }"
      >
        局部装修
      </div>
      <!-- <div @click="openFirstOnestopCase" class="item" :class="{'anchored':anchor == '#anchor-2'}">定制整装</div> -->
    </div>
    <div class="general-tab-part supervisor-tab" id="anchor-0">
      <div
        @click="selectSynthesize()"
        class="tab-item"
        :class="{ selected: currentTab == '1' }"
      >
        {{ selectedSynthesizeText }}
        <img
          v-if="currentTab != '1'"
          src="../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && isSelectSynthesize"
          src="../../assets/icon-supervisor-sort-up1.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && !isSelectSynthesize"
          src="../../assets/icon-supervisor-sort-down1.png"
        />
      </div>
      <div
        @click="selectArea()"
        class="tab-item"
        :class="{ selected: currentTab == '2' }"
      >
        {{ selectedAreaText }}
        <img
          v-if="currentTab != '2'"
          src="../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && isSelectArea"
          src="../../assets/icon-supervisor-sort-up1.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && !isSelectArea"
          src="../../assets/icon-supervisor-sort-down1.png"
        />
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectSynthesize">
      <div class="select-list">
        <div
          class="select-item"
          v-for="synthesizeItem in synthesizeList"
          :class="{ selected: synthesizeItem.value == synthesize }"
          @click="updateSynthesize(synthesizeItem, '1')"
        >
          {{ synthesizeItem.text }}
        </div>
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectArea">
      <div class="area-select-list">
        <div
          class="select-item"
          v-for="area in areaList"
          :class="{ selected: area.id == selectedAreaId }"
          @click="updateArea(area, '1')"
        >
          {{ area.name }}
        </div>
      </div>
    </div>
    <div
      class="supervisor-item"
      v-for="(foreman, index) in gangmasterList"
      :style="index === 0 ? 'paddingTop:0' : ''"
    >
      <img
        class="supervisor-avatar"
        :src="imgUrl + foreman.avatar"
        @click="DetailGangmaster(foreman)"
      />
      <div class="supervisor-info" @click="DetailGangmaster(foreman)">
        <div class="first-line">
          <div class="left">
            <div class="name">{{ foreman.name }}</div>
            <!-- 隐藏评分 -->
            <!-- <div class="score-part">
              <div class="score">{{foreman.score | serviceScoreConvert}}</div>
            </div> -->
          </div>
        </div>
        <div class="appointment-info">
          <img src="../../assets/icon-appointment-num.png" />预约名额<span
            class="num"
            >{{ foreman.spares }}</span
          >
        </div>
        <div class="less-info">
          <div class="case-info">
            <img src="../../assets/icon-case-num.png" />案例<span class="num">{{
              foreman.projectCount
            }}</span>
          </div>
          <div class="case-info" v-if="foreman.deposit">
            <img src="../../assets/icon-app-deposit.png" />订金<span
              class="num deposit"
              >{{ foreman.deposit }}</span
            >
          </div>
        </div>
      </div>

      <div
        v-if="foreman.spares != 0"
        class="appoint-btn"
        @click="openGangmasterReservation(foreman)"
      >
        预 约
      </div>
      <div
        v-if="foreman.spares == 0"
        class="full-btn"
        @click="openGangmasterReservation(foreman)"
      >
        已 满
      </div>
    </div>

    <div class="section-title" id="anchor-1" style="padding-bottom: 0rem">
      局部装修
    </div>
    <div class="general-tab-part supervisor-tab">
      <div
        @click="selectSynthesize()"
        class="tab-item"
        :class="{ selected: currentTab == '1' }"
      >
        {{ partSynthesizeText }}
        <img
          v-if="currentTab != '1'"
          src="../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && isSelectSynthesize"
          src="../../assets/icon-supervisor-sort-up.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && !isSelectSynthesize"
          src="../../assets/icon-supervisor-sort-down.png"
        />
      </div>
      <div
        @click="selectArea()"
        class="tab-item"
        :class="{ selected: currentTab == '2' }"
      >
        {{ partAreaText }}
        <img
          v-if="currentTab != '2'"
          src="../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && isSelectArea"
          src="../../assets/icon-supervisor-sort-up.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && !isSelectArea"
          src="../../assets/icon-supervisor-sort-down.png"
        />
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectSynthesize">
      <div class="select-list">
        <div
          class="select-item"
          v-for="synthesizeItem in synthesizeList"
          :class="{ selected: synthesizeItem.value == partSynthesize }"
          @click="updateSynthesize(synthesizeItem, '2')"
        >
          {{ synthesizeItem.text }}
        </div>
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectArea">
      <div class="area-select-list">
        <div
          class="select-item"
          v-for="area in areaList"
          :class="{ selected: area.id == partSelectedAreaId }"
          @click="updateArea(area, '2')"
        >
          {{ area.name }}
        </div>
      </div>
    </div>
    <div
      class="supervisor-item"
      v-for="(foreman, index) in foremanList"
      :style="index === 0 ? 'paddingTop:0' : ''"
    >
      <img
        class="supervisor-avatar"
        :src="imgUrl + foreman.avatar"
        @click="DetailGangmaster(foreman)"
      />
      <div class="supervisor-info" @click="DetailGangmaster(foreman)">
        <div class="first-line">
          <div class="left">
            <div class="name">{{ foreman.name }}</div>
            <div class="score-part">
              <div class="score">{{ foreman.score | serviceScoreConvert }}</div>
            </div>
          </div>
        </div>
        <div class="appointment-info">
          <img src="../../assets/icon-appointment-num.png" />预约名额<span
            class="num"
            >{{ foreman.spares }}</span
          >
        </div>
        <div class="less-info">
          <div class="case-info">
            <img src="../../assets/icon-case-num.png" />案例<span class="num">{{
              foreman.projectCount
            }}</span>
          </div>
          <div class="case-info" v-if="foreman.deposit">
            <img src="../../assets/icon-app-deposit.png" />订金<span
              class="num deposit"
              >{{ foreman.deposit }}</span
            >
          </div>
        </div>
      </div>
      <div
        v-if="foreman.spares != 0"
        class="appoint-btn"
        @click="openGangmasterReservation(foreman)"
      >
        预 约
      </div>
      <div
        v-if="foreman.spares == 0"
        class="full-btn"
        @click="openGangmasterReservation(foreman)"
      >
        已 满
      </div>
    </div>

    <div class="section-title" style="padding-bottom: 0">厨卫定制装修</div>
    <div class="case-item" style="margin-bottom: 0.65rem;">
      <img
        :src="imgUrl + quoteArticle.cover"
        @click="openArticleDetail(quoteArticle.id)"
      />
      <div class="info-part">
        <div class="left-info" @click="openArticleDetail(quoteArticle.id)">
          <span class="title">{{ quoteArticle.title }}</span>
        </div>
      </div>
    </div>

    <!-- <div id="anchor-2" class="section-title" style="padding-bottom: 0">优享整装</div>
    <div class="case-item" style="margin-bottom: 0.65rem;" v-for="(onestopCase) in onestopCaseList" >
      <img :src="imgUrl + onestopCase.cover" @click="openOnestopCaseDetail(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">
      <div class="info-part">
        <div class="left-info" @click="openOnestopCaseDetail(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">
          <span class="title">{{onestopCase.title}}</span>
          <span v-if="onestopCase.price>0" class="price">{{onestopCase.price}}元/㎡</span>
        </div>
        <div class="appointment-btn" @click="openOnestopReservation(onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId)">预 约</div>
      </div>
    </div> -->
    <!-- <div class="section-title">施工规范</div>
    <div v-if="articleList.length>0" class="construction-norm-list">
      <div v-for="(article,index) in articleList" @click="openArticleDetail(article.id,article.title)" class="construction-norm-item" :class="{'construction-norm-space':index%2 != 1}">
        <div class="construction-norm-title">{{article.title}}</div>
        <img class="construction-norm-item-bg" :src="imgUrl + article.cover">
      </div>
    </div>
    <div v-if="articleList.length==0" class="black-page">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关施工规范!</div>
    </div> -->
  </div>
</template>

<script>
import { imgUrl, shareIcon } from "../../config";
import { Toast } from "mint-ui";
import Header from "../../components/header/Header";
import session from "../../utils/Session";
import SupervisorService from "../../service/SupervisorService";
import CmsArticleService from "../../service/article/ArticleService";
import shareService from "../../service/share/ShareService";
import areaService from "../../service/core/AreaService";
import OnestopProjectService from "../../service/onestop/OnestopProjectService";
import appLinkService from "../../service/cloud/AppLinkService";
import axios from "axios";

export default {
  name: "GangmasterSeek",
  components: {
    "my-header": Header,
  },
  data() {
    return {
      anchor: "#anchor-0",
      synthesize: "0",
      synthesizeList: [
        { value: 0, text: "综合排序" },
        { value: 1, text: "评价优选" },
        { value: 2, text: "成单数由高到低" },
        { value: 3, text: "案例由高到低" },
        { value: 4, text: "案例由低到高" },
      ],
      decorateTypeList: [
        { value: "1", text: "整体装修" },
        { value: "2", text: "局部装修" },
      ],
      receiptAreaList: [],
      gangmasterList: [],
      imgUrl: imgUrl,
      shareIcon: shareIcon,
      subCategoryId: 22,
      articleList: [],
      isWechatBrowser: this.$verfyBrowserType(),
      areaList: [],
      showSelectPart: false,
      selectedAreaId: "",
      selectedDecorateTypeId: "",
      selectedAreaText: "接单区域",
      selectedSynthesizeText: "综合排序",
      partAreaText: "接单区域",
      partSynthesizeText: "综合排序",
      partSynthesize: "0",
      partSelectedAreaId: "",
      selectedDecorateTypeText: "装修类型",
      selected: "1",
      isSelectArea: false,
      isSelectSynthesize: false,
      isSelectDecorateType: false,
      currentTab: "1",
      type: "1",
      companyId: "2",
      onestopCaseList: [],
      foremanList: [],
      quoteArticleId: 205,
      quoteArticle: {},
      // 超链接数据
      linkData: [],
      searchKeyword: "",
    };
  },
  created() {
    if (this.global.synthesize) {
      this.synthesize = this.global.synthesize;
      this.global.synthesize = "";
    }
    if (this.global.selectedAreaId) {
      this.selectedAreaId = this.global.selectedAreaId;
      this.global.selectedAreaId = "";
    }
    if (this.global.selectedAreaText) {
      this.selectedAreaText = this.global.selectedAreaText;
      this.global.selectedAreaText = "";
    }
    this.getGangmasterLinkList();
  },
  beforeMount() {
    document.title = this.$route.meta.title;
    this.getGangmasterList();
    this.getArticleList();
    this.initWechatShare();
    this.loadAreaList();
    this.getOnestopCaseList();
    this.getForemanList();
    this.getQuoteArticle();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "Index") {
      this.global.synthesize = "";
      this.global.selectedAreaId = "";
      this.global.selectedAreaText = "";
      from.meta.keepAlive = false;
      this.$destroy();
      next();
    } else {
      this.global.synthesize = this.synthesize;
      this.global.selectedAreaId = this.selectedAreaId;
      this.global.selectedAreaText = this.selectedAreaText;
      from.meta.keepAlive = true;
      next();
    }
  },
  methods: {
    // 获取优选工长超链接
    async getGangmasterLinkList() {
      const result = await appLinkService.list(2);
      this.linkData = result.data;
    },
    // 超链接详情
    async toLinkdetail(id) {
      const res = await appLinkService.get(id);
      let detailLink = res.data;
      if (this.global.isMiniProgrm && detailLink.refTypeValue == 1) {
        wx.miniProgram.navigateTo({
          url: `/pages/article/detail/detail?articleId=${detailLink.refId}`,
        });
      } else if (this.global.isMiniProgrm && detailLink.refTypeValue == 2) {
        wx.miniProgram.navigateTo({
          url: `/pages/circle/detail/detail?articleId=${detailLink.refId}`,
        });
      } else {
        this.$router.push({
          name: "ArticleDetail",
          query: { articleId: detailLink.refId, title: detailLink.name },
        });
      }
    },
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView();
      this.anchor = selector;
    },
    openFirstOnestopCase() {
      const { onestopCaseList = [] } = this;
      if (onestopCaseList.length > 0) {
        const first = onestopCaseList[0];
        //onestopCase.id,onestopCase.title,onestopCase.price,onestopCase.companyId
        this.openOnestopCaseDetail(
          first.id,
          first.title,
          first.price,
          first.companyId
        );
      }
    },
    selectArea() {
      this.showSelectPart = true;
      this.isSelectSynthesize = false;
      this.isSelectDecorateType = false;
      this.isSelectArea = !this.isSelectArea;
      this.currentTab = "2";
    },
    selectDecorateType() {
      this.showSelectPart = true;
      this.isSelectSynthesize = false;
      this.isSelectArea = false;
      this.isSelectDecorateType = !this.isSelectDecorateType;
      this.currentTab = "3";
    },
    selectSynthesize() {
      this.showSelectPart = true;
      this.isSelectArea = false;
      this.isSelectDecorateType = false;
      this.isSelectSynthesize = !this.isSelectSynthesize;
      this.currentTab = "1";
    },
    async updateSynthesize(synthesize, decorateType) {
      this.showSelectPart = !this.showSelectPart;
      if (decorateType == "1") {
        this.synthesize = synthesize.value;
        this.selectedSynthesizeText = synthesize.text;
        this.getGangmasterList();
      } else {
        this.partSynthesize = synthesize.value;
        this.partSynthesizeText = synthesize.text;
        this.getForemanList();
      }
      this.isSelectSynthesize = !this.isSelectSynthesize;
    },
    async updateArea(area, decorateType) {
      this.showSelectPart = !this.showSelectPart;
      if (decorateType == "1") {
        this.selectedAreaId = area.id;
        this.selectedAreaText = area.name;
        this.getGangmasterList();
      } else {
        this.partSelectedAreaId = area.id;
        this.partAreaText = area.name;
        this.getForemanList();
      }
      this.isSelectArea = !this.isSelectArea;
    },
    async updateDecorateType(decorateType) {
      this.showSelectPart = !this.showSelectPart;
      this.selectedDecorateTypeId = decorateType.value;
      this.selectedDecorateTypeText = decorateType.text;
      this.getGangmasterList();
      this.isSelectDecorateType = !this.isSelectDecorateType;
    },
    async loadAreaList() {
      let result = await areaService.getAreaList(2);
      this.areaList = result.data;
    },
    async initWechatShare() {
      let title = "水木家居商城优选工长"; // 分享标题
      let desc = "水木工长，一站式工长服务，用口碑和实力技艺说话！"; // 分享描述
      let link = window.location.href; // 分享链接
      link = link.replace(/#/, "?#");
      await shareService.wechatShare(title, desc, link, this.shareIcon);
    },
    DetailGangmaster(gangmaster) {
      this.$router.push({
        name: "GangmasterDetail",
        query: { supervisorId: gangmaster.id, supervisorName: gangmaster.name },
      });
    },
    openGangmasterReservation(gangmaster) {
      if (gangmaster.appointmentSwitch != "1") {
        Toast("该工长暂时不接受预约!");
      } else if (
        gangmaster.appointmentSwitch == "1" &&
        gangmaster.spares == 0
      ) {
        Toast("该工长预约已满!");
      } else {
        if (!!this.global.isMiniProgrm) {
          session.isLogin().then((flag) => {
            if (flag) {
              wx.miniProgram.navigateTo({
                url: `/pages/gangmaster/reservation?id=${
                  gangmaster.id
                }&companyId=${gangmaster.companyId}&deposit=${
                  gangmaster.deposit
                }&supervisorName=${gangmaster.name}`,
              });
            } else {
              let backUrl = this.$route.fullPath;
              wx.miniProgram.navigateTo({
                url: `/pages/register/register?h5Url=${encodeURIComponent(
                  backUrl
                )}`,
              });
            }
          });
        } else {
          this.$router.push({
            name: "GangmasterReservation",
            query: {
              id: gangmaster.id,
              companyId: gangmaster.companyId,
              supervisorName: gangmaster.name,
              deposit: gangmaster.deposit,
            },
          });
        }
      }
    },
    async getGangmasterList() {
      let result = await SupervisorService.getSupervisorList(
        "2",
        this.synthesize,
        this.selectedAreaId,
        "1"
      );
      if (result.code == 0) {
        this.gangmasterList = [];
        if (this.synthesize != 0) {
          this.gangmasterList = result.data;
        } else {
          let closeSwitchForemans = [];
          let withoutSparesForemans = [];
          for (let foreman of result.data) {
            if (foreman.appointmentSwitch != 1 && foreman.spares != 0) {
              closeSwitchForemans.push(foreman);
            } else if (foreman.spares == 0) {
              withoutSparesForemans.push(foreman);
            } else {
              this.gangmasterList.push(foreman);
            }
          }
          this.gangmasterList = this.gangmasterList.concat(closeSwitchForemans);
          this.gangmasterList = this.gangmasterList.concat(
            withoutSparesForemans
          );
        }
        for (let supervisor of this.gangmasterList) {
          if (supervisor.decorateType) {
            let decorateTypeArr = supervisor.decorateType.split(",");
            this.$set(supervisor, "decorateTypeArr", decorateTypeArr);
          }
        }
      } else {
        Toast("获取工长列表信息失败");
      }
    },

    async getForemanList() {
      let result = await SupervisorService.getSupervisorList(
        "2",
        this.partSynthesize,
        this.partSelectedAreaId,
        "2"
      );
      if (result.code == 0) {
        this.foremanList = [];
        if (this.partSynthesize != 0) {
          this.foremanList = result.data;
        } else {
          let closeSwitchForemans = [];
          let withoutSparesForemans = [];
          for (let foreman of result.data) {
            if (foreman.appointmentSwitch != 1) {
              closeSwitchForemans.push(foreman);
            } else if (foreman.spares == 0) {
              withoutSparesForemans.push(foreman);
            } else {
              this.foremanList.push(foreman);
            }
          }
          this.foremanList = this.foremanList.concat(closeSwitchForemans);
          this.foremanList = this.foremanList.concat(withoutSparesForemans);
        }
        for (let supervisor of this.foremanList) {
          if (supervisor.decorateType) {
            let decorateTypeArr = supervisor.decorateType.split(",");
            this.$set(supervisor, "decorateTypeArr", decorateTypeArr);
          }
        }
      } else {
        Toast("获取工长列表信息失败");
      }
    },
    async getArticleList() {
      let {
        code,
        data: { result },
      } = await CmsArticleService.list(this.subCategoryId, "", "", 1);
      if (code == 0) {
        this.articleList = result;
        for (let article of this.articleList) {
          if (article.title.length > 19) {
            article.title = article.title.substring(0, 18) + "...";
          }
        }
        this.getArticleListLastPage();
      } else {
        Toast("获取施工规范信息失败");
      }
    },
    async getQuoteArticle() {
      let { code, data } = await CmsArticleService.detail(this.quoteArticleId);
      if (code == 0) {
        this.quoteArticle = data;
        if (this.quoteArticle.title.length > 16) {
          this.quoteArticle.title =
            this.quoteArticle.title.substring(0, 13) + "...";
        }
      } else {
        Toast("获取局部装修报价信息失败");
      }
    },
    async getArticleListLastPage() {
      let {
        code,
        data: { result },
      } = await CmsArticleService.list(this.subCategoryId, "", "", 2);
      if (code == 0) {
        for (let article of result) {
          if (article.title.length > 19) {
            article.title = article.title.substring(0, 18) + "...";
          }
          this.articleList.push(article);
        }
      } else {
        Toast("获取施工规范信息失败");
      }
    },
    async getOnestopCaseList() {
      var result = await OnestopProjectService.getOnestopCaseList(
        this.companyId
      );
      if (result.code == 0) {
        this.onestopCaseList = result.data;
      } else {
        Toast("获取优享整装信息失败");
      }
    },
    openArticleDetail(id, title) {
      this.$router.push({
        name: "ArticleDetail",
        query: { articleId: id, title },
      });
    },
    openOnestopCaseDetail(id, caseTitle, casePrice, companyId) {
      this.$router.push({
        name: "OnestopDetail",
        query: { id, caseTitle, casePrice, companyId },
      });
    },
    async openOnestopReservation(
      onestopCaseId,
      caseTitle,
      casePrice,
      companyId
    ) {
      if (!!this.global.isMiniProgrm) {
        session.isLogin().then((flag) => {
          if (flag) {
            wx.miniProgram.navigateTo({
              url: `/pages/onestop/book/book?onestopCaseId=${onestopCaseId}&caseTitle=${caseTitle}&casePrice=${casePrice}&companyId=${companyId}`,
            });
          } else {
            let backUrl = this.$route.fullPath;
            wx.miniProgram.navigateTo({
              url: `/pages/register/register?h5Url=${encodeURIComponent(
                backUrl
              )}`,
            });
          }
        });
      } else {
        this.$router.push({
          name: "OnestopReservation",
          query: { onestopCaseId, caseTitle, casePrice, companyId },
        });
      }
    },
    handleSearchClick() {
      const { searchKeyword } = this;
      if (!searchKeyword) {
        Toast("请输入关键字后再进行搜索");
        return;
      }
      this.$router.push(`/gangmaster/seek/search?keyword=${searchKeyword}`);
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/style/supervisor-list.scss";
.supervisor-list {
  background: white;
  font-size: 0.36rem;
  .foreman-top {
    padding: 0.47rem 0.34rem 0.3rem;
    font-size: 0.34rem;
    color: white;
    font-weight: bold;
    background: #c4a183;
  }
  .foreman-flow-part {
    height: 1.9rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .icon-advert {
    display: block;
    width: 6.9rem;
    height: 1.5rem;
    margin: 0.34rem auto 0;
  }
  .anchor-list {
    display: flex;
    justify-content: space-around;
    margin-left: 0.32rem;
    margin-right: 0.32rem;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
    font-weight: bold;
    border-bottom: solid 1px #eee;
    .item {
      height: 0.88rem;
      line-height: 0.9rem;
      font-size: 0.34rem;
      color: #999;
    }
    .anchored {
      position: relative;
      color: #333;
    }
    .anchored:after {
      content: "";
      position: absolute;
      top: 0.8rem;
      left: 25%;
      bottom: 0;
      right: 0;
      width: 0.5rem;
      height: 0.08rem;
      background-color: #333;
    }
  }
  .case-item {
    width: 6.8rem;
    margin: 0.34rem auto 0;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 4rem;
      border-radius: 0.1rem;
    }
    .info-part {
      display: flex;
      position: absolute;
      top: 3.25rem;
      width: 100%;
      .left-info {
        margin-left: 0.35rem;
        color: white;
        font-weight: bold;
      }
      .appointment-btn {
        position: absolute;
        right: 0.3rem;
        width: 1.3rem;
        height: 0.6rem;
        border-radius: 0.1rem;
        line-height: 0.62rem;
        border: solid 1px #ffffff;
        text-align: center;
        font-size: 0.3rem;
        color: white;
      }
    }
  }
  .construction-norm-list {
    display: flex;
    flex-flow: row wrap;
    padding-left: 0.3rem;
    padding-bottom: 0.5rem;
    font-size: 0.32rem;
    .construction-norm-item {
      position: relative;
    }
    .construction-norm-title {
      position: absolute;
      top: 0.38rem;
      left: 0.18rem;
      width: 3.1rem;
      color: white;
    }
    .construction-norm-item-bg {
      width: 3.3rem;
      height: 1.4rem;
      border-radius: 0.08rem;
      margin-bottom: 0.2rem;
    }
    .construction-norm-space {
      margin-right: 0.2rem;
    }
  }
}
// 超链接样式
.Hyperlinks {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  margin: 0.2rem 0.5rem;
  font-size: 0.26rem;
}
.Hyperlinks-content {
  padding-top: 0.26rem;
  margin-right: 0.4rem;
}
.noimg {
  text-align: center;
}
.search-container {
  width: 100%;
  .border {
    width: 100%;
    height: 0.2rem;
    background-color: #eee;
  }
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.32rem;
    .input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100px;
      height: 0.6rem;
      flex-grow: 1;
      flex-shrink: 1;
      background-color: #f7f7f6;
      border-radius: 0.05rem;
      padding: 0 0.2rem;
      .search-icon {
        display: block;
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.2rem;
      }
      .input-inner {
        display: block;
        width: 100%;
        height: 100%;
        background: none;
        font-size: 0.26rem;
        &::-webkit-input-placeholder,
        &:-moz-placeholder,
        &::-moz-placeholder,
        &:-ms-input-placeholder {
          color: #bababa;
        }
      }
    }
    .btn {
      flex-grow: 0;
      flex-shrink: 0;
      margin-left: 0.2rem;
      color: #1d8ae7;
      font-size: 0.28rem;
    }
  }
}
</style>
